import { FC } from 'react';

import operationTypes from 'constants/operationTypes';

import DefaultTableBody from '../components/DefaultTableBody';
import SharesTransferTableBody from '../components/SharesTransfer/SharesTransferTableBody';
import ReclassificationTableBody from '../components/Reclassification/ReclassificationTableBody';

export const historyMovementsViewExpandedTableBodyMap: Record<string, FC> = {
  [operationTypes.CONSTITUTION]: DefaultTableBody,
  [operationTypes.CAPITAL_INCREASE]: DefaultTableBody,
  [operationTypes.CAPITAL_DECREASE]: DefaultTableBody,
  [operationTypes.SELL_PARTICIPATION]: SharesTransferTableBody,
  [operationTypes.HERITAGE]: SharesTransferTableBody,
  [operationTypes.DONATION]: SharesTransferTableBody,
  [operationTypes.ENDORSEMENT]: SharesTransferTableBody,
  [operationTypes.TRANSMISSION]: SharesTransferTableBody,
  [operationTypes.RECLASSIFICATION]: ReclassificationTableBody,
};
